import { EnumWojewodztwo } from 'app/services/wojewodztwa.service';

export class Oferent {
    id: string;
    nazwa = '';
    adres = '';
    email = '';
    tel = '';
    www = '';
    info = '';
    wojewodztwa = [false, false, false, false];
    confirmed = false;

    getAdres(): string {
        return this.adres.replace(/\n/gi, '<br>');
    }
    getInfo(): string {
        return this.info.replace(/\n/gi, '<br>');
    }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/model/oferent.ts